<template>
  <div class="container">
    <h2>Productos Publicados</h2>
    <app-table v-model="controls" :api="apiProductos" :fields="fields">
      <template slot="header">
        <i class="fas fa-drumstick-bite"></i> Productos
      </template>
      <!-- Un Row -->
      <template slot="tr-item" slot-scope="product">
        <td class="text-right">
          <texto-resaltado
            :text="product.row.producto_id + ''"
            :query="controls.query"
          >
          </texto-resaltado>
        </td>
        <td>
          <texto-resaltado
            :text="product.row.producto.nombre"
            :query="controls.query"
          >
          </texto-resaltado>
        </td>
        <td class="text-center">{{ product.row.producto.unit_medida }}</td>
        <td class="text-center">{{ product.row.precio }}</td>
        <td class="text-center">
          <button
            class="btn btn-primary m-1"
            v-on:click="sumar_existencia(product.row)"
          >
            {{ product.row.stock }} {{ product.row.producto.unit_medida }}
          </button>
        </td>
        <td class="acciones">
          <!-- <pre>{{ product.row }}</pre> -->
          <div class="btn-group">
            <router-link
              class="btn btn-warning btn-block"
              :to="{
                name: 'productoPublicar',
                params: { id: product.row.producto_id }
              }"
            >
              <i class="fas fa-edit"></i> Editar
            </router-link>
            <button
              :class="class_mostrar(product.row)"
              v-on:click="ocultar(product.row)"
            >
              {{ text_mostrar(product.row) }}
            </button>
          </div>
        </td>
      </template>
      <!-- Fin row -->
    </app-table>
    <b-modal id="editar-stock" :title="tituloModal" hide-footer>
      <div v-if="prodEditado" class="form-group">
        <label>Agregar Existencias</label>
        <input
          class="form-control"
          type="number"
          step="any"
          v-model="prodEditado.sumar"
        />
        <button
          class="btn btn-danger float-right m-1"
          v-on:click="$bvModal.hide('editar-stock')"
        >
          Cancelar
        </button>
        <button
          class="btn btn-success float-right m-1"
          v-on:click="sumar_stock"
        >
          Guardar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss"></style>

<script>
import Producto from "../../apis/ProductoPublicado";

export default {
  data() {
    return {
      prodEditado: null,
      tituloModal: "",
      apiProductos: Producto,
      controls: {
        current_page: 1,
        per_page: 10,
        total: 0,
        query: "",
        sort_column: "producto_id",
        sort_order: "desc",
        relations: ["producto"]
      },
      fields: [
        { display: "Folio", field: "id", sort: true },
        { display: "Nombre", field: "nombre", sort: true },
        { display: "Unidad", field: "unit_medida", sort: true },
        { display: "Precio", field: "precio", sort: true },
        { display: "Existencia", field: "stock", sort: true },
        { display: "Acciones" }
      ]
    };
  },
  created() {},
  components: {},
  methods: {
    sumar_existencia(p) {
      this.prodEditado = p;
      this.prodEditado.sumar = 0;
      this.tituloModal =
        "Existen " +
        p.stock +
        " " +
        p.producto.unit_medida +
        " de " +
        p.producto.nombre;
      this.$bvModal.show("editar-stock");
    },
    sumar_stock() {
      this.$bvModal.hide("editar-stock");
      Producto.sumar_stock(this.prodEditado).then(r => {
        if (r.data.error) {
          alert(r.data.message);
        } else {
          this.prodEditado.stock = r.data.prod.stock;
        }
      });
    },
    ocultar(p) {
      Producto.ocultar(p).then(r => {
        if (r.data.error) {
          alert(r.data.message);
        } else {
          p.publicado = r.data.prod.publicado;
        }
      });
    },
    text_mostrar(p) {
      return p.publicado ? "Ocultar" : "Mostrar";
    },
    class_mostrar(p) {
      return p.publicado ? "btn btn-danger" : "btn btn-success";
    }
  }, // end methods
  computed: {}
};
</script>
